import fromQueryString from '@creuna/utils/from-query-string';
import replaceQueryParameters from '@creuna/utils/replace-query-parameters';
const _inQueryStringArrayDelimiter = '~';

const _getUndefinedIfEmpty = value => {
    return !value || value === '' || value.length === 0 ? undefined : value;
};

const getFilterSelectedValues = (filter, activeFilter) => {
    const activeFilterItem = filter.items.find(item => item.key == activeFilter);
    return activeFilterItem ? activeFilterItem.key : null;
};

const createQuery = () => {
    return new Object();
};

const setQueryValue = (query, name, value) => {
    query[name] = _getUndefinedIfEmpty(value);
};

const setToQueryFilterOptions = (query, filter, name, activeFilter) => {
    if (!filter) {
        return;
    }

    setQueryValue(
        query,
        name,
        getFilterSelectedValues(filter, activeFilter));
};

const setToQueryTextInputValue = (query, name, currentValue = null) => {
    setQueryValue(query, name, currentValue);
};

const updatePageQueryString = query => {
    query = { ...query };
    for (var key in query) {
        var value = query[key];
        if (Array.isArray(value))
            query[key] = value.join(_inQueryStringArrayDelimiter);
    }
    var newUrl = replaceQueryParameters(window.location.toString(), query);
    window.history.replaceState({}, document.title, newUrl);
};

const fillQueryFromPageQueryString = query => {
    var parsedQuery = fromQueryString(window.location.search.replace(/\+/g, ' '));
    for (var key in parsedQuery) {
        var value = parsedQuery[key];
        if (value.includes(_inQueryStringArrayDelimiter))
            parsedQuery[key] = value.split(_inQueryStringArrayDelimiter);
    }
    Object.assign(query, parsedQuery);
};

export default {
    createQuery,
    setQueryValue,
    getFilterSelectedValues,
    setToQueryFilterOptions,
    setToQueryTextInputValue,
    updatePageQueryString,
    fillQueryFromPageQueryString
};


// WEBPACK FOOTER //
// ./src/js/form-helper.js